import styled from 'styled-components';

interface ContainerProps {
  isOnsiteStaff: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    margin-bottom: 32px;
  }
  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    .MuiFormControl-root {
      width: 360px;
      margin-bottom: 26px;
    }
    .MuiAutocomplete-root {
      width: 360px;
    }
    .MuiAutocomplete-input {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
export const StyledAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: initial;
    text-align: center;
  }
`;
